import React from 'react';

import withDbItemsWrapper from '../../../utils/hoc/dbItemsWrapper';
import SolutionModal from './components/modals/SolutionModal';
import SolutionDetailView from './components/SolutionDetailView';

export function createSolutionsView(title: string) {
  return function Solutions({ detail, openDialog, isEdit, handleSubmit, handleEdit, handleClose }) {
    return (
      <div className="flex-1 min-w-0 flex flex-col">
        {detail && <SolutionDetailView data={detail} onEdit={handleEdit} />}
        <SolutionModal
          title={title}
          visible={openDialog}
          formProps={isEdit ? detail : null}
          classification={[]}
          onSubmit={handleSubmit}
          onClose={handleClose}
        />
      </div>
    );
  };
}

export const ALL_SOLUTION_KINDS = 'solution,pattern,finish';

export default withDbItemsWrapper(
  createSolutionsView('Řešení'),
  'solution',
  `left-panel-solution/?kind=${ALL_SOLUTION_KINDS}`,
  '/app/data/reseni/reseni/',
  { apiName: 'solution', extraParams: { kind: ALL_SOLUTION_KINDS } }
);
